/*******************************************************************************
 * Project:
 * Summary:
 *      Define ScrExamToppageComponent component.
 * Remarks:
 *      Define functions toppage .
 * History:
 *      LuanNX            2021/12/14     Create new
******************************************************************************/
import { DatePipe } from '@angular/common';
import { Component, HostListener, OnInit, TemplateRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { LoadingService } from 'src/app/layout/loading/loading.service';
import { CommonService } from 'src/app/services/common.service';
import { DialogModalService } from 'src/app/shared/dialog-modal/dialog-modal.service';
import { Utility } from 'src/app/shared/utility/utility';
import * as _ from 'lodash';
import { ScrExamToppageService } from 'src/app/modules/examinee/toppage/scr-exam-toppage/scr-exam-toppage.service';
import {
  Router,
} from '@angular/router';
import { ScreenMode } from 'src/app/shared/screen-mode';
import { GetIMstHTOrg } from 'src/app/store/actions/mstHTOrg.action';
import { IAppState } from 'src/app/store/states/app.state';
import { Store } from '@ngrx/store';
@Component({
  selector: 'app-scr-exam-toppage',
  templateUrl: './scr-exam-toppage.component.html',
  styleUrls: ['./scr-exam-toppage.component.scss']
})
export class ScrExamToppageComponent implements OnInit {
  lstInfoHtRsv = [];
  lstInfoInterviewRecept = [];
  sysDay: any;
  isInit = false;
  constructor(
    public util: Utility,
    private popupService: NgbModal,
    public trans: TranslateService,
    private dtPipe: DatePipe,
    private dialogModalService: DialogModalService,
    private loading: LoadingService,
    private common: CommonService,
    private service: ScrExamToppageService,
    public router: Router,
    private store: Store<IAppState>,
  ) { }
  ngOnInit(): void {
    const objHTOrg = {
      HTOrgCode: null,
      HTOrgName: null,
    };
    this.store.dispatch(new GetIMstHTOrg(objHTOrg));
    this.util.resetZoomBrowser();
    this.util.addPerfectScrollBar();
    this.isInit = true;
    this.getInfo();
  }
  getInfo() {
    if (this.util.isNullOrEmpty(localStorage.ExamineauthorizationData)) {
      return;
    }
    this.loading.setDisplay(true);
    this.service.getInfoTopPage().subscribe(res => {
      this.loading.setDisplay(false);
      if (this.util.isNullOrEmpty(res) || res.length === 0) {
        this.isInit = false;
        return;
      }
      this.sysDay = res.ServerDay;
      this.lstInfoHtRsv = res.LstInfoHtRsv;
      this.lstInfoInterviewRecept = res.LstInfoInterviewRecept;
      this.isInit = false;
    });
  }
  getDayName(value, dayOfweek) {
    if (value == null || value.length < 8) {
      return '';
    }
    const y = value.substring(0, 4);
    const m = parseFloat(value.substring(4, 6));
    const d = parseFloat(value.substring(6));
    let day = y + '年' + m + '月' + d + '日';
    const lang = localStorage.getItem('language');
    if (lang === 'vi') {
      day = d + '/' + m + '/' + y;
    }
    else if (lang === 'en') {
      day = y + '/' + m + '/' + d;
    }
    const strNameDay = this.util.getNameDay(dayOfweek);
    return day + ' ' + (strNameDay ? '(' + this.trans.instant(strNameDay) + ')' : '');
  }
  getTimeDisplay(value) {
    if (value == null || value.trim().length <= 2) {
      return '';
    }
    value = value.trim();
    if (value.length === 3) {
      return value.substring(0, 1) + ':' + value.substring(1);
    }
    return value.substring(0, 2) + ':' + value.substring(2);
  }
  isEnbledInCom(info) {
    const { RsvDate, WebRsvDay, compareDate } = info;
    if (info === null || this.util.isNullOrEmpty(RsvDate) || this.util.isNullOrEmpty(WebRsvDay)) {
      return false;
    }
    const serverDay = parseFloat(this.sysDay.replace(/\//g, ''));
    const compareDay = parseFloat(compareDate);
    if ((serverDay <= compareDay)) return true;
    return false;
  }

  getWarning(it) {
    // tslint:disable-next-line: max-line-length
    const phone = this.util.ReplaceAll(this.util.setAreaNumber(it.InquiryPhoneNum?.trim()), ' ', '-');
    // tslint:disable-next-line: max-line-length
    return this.trans.instant('STR_CHANGE_RESER_WARNING1') + '<a  href="tel:' + it.InquiryPhoneNum?.trim() + '" >' + phone + '</a>' + this.trans.instant('STR_CHANGE_RESER_WARNING2');
  }
  isEnableCom(info) {
    const { RsvDate, WebRsvDay, compareDate, dayAfterWeek } = info;
    if (info === null || this.util.isNullOrEmpty(RsvDate) || this.util.isNullOrEmpty(WebRsvDay) || RsvDate.length < 8) {
      return false;
    }
    const serverDay = parseFloat(this.sysDay.replace(/\//g, ''));
    const _dayAfterWeek = parseFloat(dayAfterWeek);
    const compareDay = parseFloat(compareDate);
    if ((serverDay > compareDay) && (serverDay <= _dayAfterWeek)) return true;
    return false;
  }
  go0501(pRsv) {
    this.router.navigate(['scr-questionare-ans-inp'], {
      queryParams: {
        rsvdate: pRsv.RsvDate,
        rsvnum: pRsv.RsvNum,
        htorgcode: pRsv.HTOrgCode
      }
    });
  }
  go0307(item, type) {
    sessionStorage.removeItem('HTOrgCode');
    sessionStorage.removeItem('DataReservation');
    sessionStorage.removeItem('DataReservationOld');
    if (type === 1) {
      this.router.navigate(['reservation-detail'], {
        queryParams: {
          mode: ScreenMode.Edit, date: item.RsvDate, num: item.RsvNum, htorgcode: item.HTOrgCode
        }
      });
    } else {
      this.router.navigate(['reservation-detail'], {
        queryParams: {
          mode: ScreenMode.Confirm,
          date: item.RsvDate, num: item.RsvNum, htorgcode: item.HTOrgCode
        }
      });
    }
  }

  go0601(info) {
    this.router.navigate(['scr-exam-result'], {
      queryParams: {
        consulday: info.ConsulDay, consulnum: info.ConsulNum, htorgcode: info.HTOrgCode
      }
    });
  }
}
